import HeroSection from '@/components/custom/ui/clients/tempula/booking/heroSection'
import HomestayFooterCmp from '@/components/custom/ui/clients/tempula/homestay/homestayFooter';
import HomestayNavbar from '@/components/custom/ui/clients/tempula/homestay/homestayNavbar';
import { Room } from '@/components/custom/ui/clients/tempula/room/room';
import HomestayfooterConfig from '@/constant/config/clients/tempula/homestay/homestayFooterConfig';
import HomenavConfig from '@/constant/config/clients/tempula/homestay/homestayNavConfig';
import roomConfig from '@/constant/config/clients/tempula/room/roomConfig';
import RoomheroConfig from '@/constant/config/clients/tempula/room/roomHeroConfig'
import { createFileRoute } from '@tanstack/react-router'
import { SEO, buildPageHead } from '@/constant/config/clients/tempula/seo'

export const Route = createFileRoute('/_clients/tempula/room')({
    head: () => buildPageHead(SEO.rooms),
    component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="bg-BgGallery">
      <div className="fixed top-0 left-0 w-full z-50">
        <HomestayNavbar {...HomenavConfig} />
      </div>
      <HeroSection {...RoomheroConfig} />
      <Room {...roomConfig} />
      <HomestayFooterCmp {...HomestayfooterConfig} />
    </div>
  )
}
